export function OutlineRegresarVistaCardsIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3008 0.75C16.3008 1.28357 16.3008 1.82357 16.3008 2.35714C18.6472 1.89428 21.0258 2.85214 22.3051 4.76785C24.0344 7.35213 22.7936 10.2193 22.7165 10.3928C22.7422 10.2 23.0058 7.77642 21.1094 6.11785C19.7979 4.97357 17.9594 4.68428 16.3008 5.26928C16.3008 5.82214 16.3008 6.31713 16.3008 6.86999L11.0037 3.80357C12.7715 2.78785 14.5394 1.76571 16.3137 0.75H16.3008Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6071 10.0644V11.6909H6.85071C6.14356 11.6909 5.57142 12.2694 5.57142 12.9766V16.8209H2.02928C1.32214 16.8209 0.75 16.2487 0.75 15.5416V10.0644C0.75 9.3573 1.32214 8.78516 2.02928 8.78516H12.3214C13.035 8.78516 13.6071 9.3573 13.6071 10.0644Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.4284 12.9771V15.2143H11.672C10.9649 15.2143 10.3927 15.7864 10.3927 16.4935V19.7271H6.85057C6.14343 19.7271 5.57129 19.155 5.57129 18.4478V12.9771C5.57129 12.27 6.14343 11.6914 6.85057 11.6914H17.1427C17.8563 11.6914 18.4284 12.27 18.4284 12.9771Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M21.9704 15.2148H11.6719C10.9653 15.2148 10.3926 15.7876 10.3926 16.4941V21.9713C10.3926 22.6778 10.9653 23.2505 11.6719 23.2505H21.9704C22.6769 23.2505 23.2497 22.6778 23.2497 21.9713V16.4941C23.2497 15.7876 22.6769 15.2148 21.9704 15.2148Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
